import { render, staticRenderFns } from "./importDataPesertaPT.vue?vue&type=template&id=5477f3bc&"
import script from "./importDataPesertaPT.vue?vue&type=script&lang=js&"
export * from "./importDataPesertaPT.vue?vue&type=script&lang=js&"
import style0 from "./importDataPesertaPT.vue?vue&type=style&index=0&id=5477f3bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports